import { FC } from 'react'
import { Typography } from '@mui/material'

import { CostDistributionChipWrapper } from './costDistributionChip.styles'

interface Props {
  text?: string
}

const CostDistributionChip: FC<Props> = ({ text }) => (
  <CostDistributionChipWrapper className="cost-distribution-chip-wrapper">
    <Typography>{text || 'Current area'}</Typography>
  </CostDistributionChipWrapper>
)

export default CostDistributionChip
